module.exports = __webpack_public_path__ + "img/ik6.af760133.png";